module.exports = __webpack_public_path__ + "img/prl.3db5473a.png";